import { makeStyles, Theme } from "@material-ui/core/styles";
import { tokens } from "@cobee/cobee-ui";

interface Props {
  stateColors: string;
  isLaptop: boolean;
}

const useStyles = makeStyles<Theme, Props>(() => ({
  styleLabel: {
    background: ({ stateColors }) => `${stateColors}`,
    borderRadius: "56px",
    padding: "2px 8px",
    "& p": {
      color: tokens.palette.grey.A700,
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      textTransform: "capitalize",
    },
  },
}));

export default useStyles;
